"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompatibleEndpoint = void 0;
exports.CompatibleEndpoint = {
    Chat: "chat",
    Embed: "embed",
    Classify: "classify",
    Summarize: "summarize",
    Rerank: "rerank",
    Rate: "rate",
    Generate: "generate",
};
